<template>
  <div class="px-0 mx--1">
    <drop-zone
      ref="parentDropZone"
      :objectId="objectId"
      :media="media"
      :collectionDBname="collectionDBname"
      :photos="photos"
      :name="name"
    />
  </div>
</template>
<script>
import DropZone from "@/components/UI/DropZone"
export default {
  props: ["media", "objectId", "collectionDBname", "photos", "name"],
  data() {
    return {
      clicked: false,
    }
  },
  mounted() {
    console.log("Updated", this.objectId, this.collectionDBname)
  },
  methods: {
    reloadDropZone() {
      // not good to try
      //this.validSlug = false
      this.$refs.parentDropZone.disable()
    },
  },
  components: { DropZone },
}
</script>
<style lang="scss" scoped>
.border {
  border-style: dotted;
}
</style>
